import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChartLine, 
  faFileAlt, 
  faDatabase, 
  faRobot, 
  faSearch 
} from '@fortawesome/free-solid-svg-icons';
import './Home.css';

const AdvantagesSlider = ({ advantages }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);
  const cardWidth = useRef(0);

  const icons = [
    {
      icon: faChartLine,
      title: '財務分析'
    },
    {
      icon: faFileAlt,
      title: '財報文件'
    },
    {
      icon: faDatabase,
      title: '數據資料'
    },
    {
      icon: faRobot,
      title: 'AI 分析'
    },
    {
      icon: faSearch,
      title: '智能搜索'
    }
  ];

  useEffect(() => {
    if (sliderRef.current) {
      const card = sliderRef.current.querySelector('.advantage-card');
      if (card) {
        cardWidth.current = card.offsetWidth + 32; // 32px 是 gap
      }
    }
  }, []);

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < advantages.length - 2) {
      setCurrentIndex(prev => prev + 1);
    }
  };

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.style.transform = `translateX(-${currentIndex * cardWidth.current}px)`;
    }
  }, [currentIndex]);

  return (
    <div className="advantages-container">
      <div className="advantages-slider" ref={sliderRef}>
        {advantages.map((advantage, index) => (
          <div key={index} className="advantage-card">
            <div className="advantage-icon">
              <FontAwesomeIcon icon={icons[index].icon} />
            </div>
            <h3>{advantage.title}</h3>
            <p>{advantage.content}</p>
          </div>
        ))}
      </div>
      <div className="slider-controls">
        <button 
          className="slider-prev" 
          onClick={handlePrev}
          disabled={currentIndex === 0}
        >
          ←
        </button>
        <button 
          className="slider-next" 
          onClick={handleNext}
          disabled={currentIndex >= advantages.length - 2}
        >
          →
        </button>
      </div>
    </div>
  );
};

export default AdvantagesSlider; 